// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:00:27.381Z
// Property: Atlantic on the Boulevard (ID: 6767906449166428)
// Collections: 24 amenities, 7 floorplans (live), 21 photos, 48 POIs, 1 reviews, 15 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166428",
  "property_external_id": "79qej1y",
  "property_zillow_url": "https://www.zillow.com/apartments/north-charleston-sc/atlantic-on-the-boulevard/CjjCPT/",
  "property_apartments_url": "https://www.apartments.com/atlantic-on-the-boulevard-north-charleston-sc/79qej1y/",
  "property_google_business_url": "https://www.google.com/maps/place/Atlantic+on+the+Boulevard/data=!4m2!3m1!1s0x0:0xe7599eaa26914d76?sa=X&ved=2ahUKEwiIz7ql4aeSAxWgc_UHHeyZFNQQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40238743198",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "833AOB",
  "property_status": null,
  "property_slug": "atlantic-on-the-boulevard",
  "property_name": "Atlantic on the Boulevard",
  "property_website_url": "http://www.atlanticontheboulevard.com/",
  "property_domain": "https://www.atlanticontheboulevard.com/",
  "property_address": "2155 Morris Baker Boulevard",
  "property_full_address": "2155 Morris Baker Blvd, North Charleston, SC 29406",
  "property_address_1": "2155 Morris Baker Blvd",
  "property_address_2": null,
  "property_address_city": "North Charleston",
  "property_address_state": "SC",
  "property_address_zip_full": null,
  "property_address_zip": "29406",
  "property_address_country": "US",
  "property_address_county": "Charleston County",
  "property_neighborhood_address": "North Charleston",
  "property_address_latitude": "32.9299127",
  "property_address_longitude": "-80.04266439999999",
  "property_email": null,
  "property_phone": "(854) 220-5183",
  "property_call_tracking_phone": "855-481-6175",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Atlantic on the Boulevard in North Charleston, SC, where modern living meets resort-style amenities. Choose from spacious one-, two-, or three-bedroom floor plans, featuring stainless steel appliances and walk-in closets. Unwind by the resort-style pool or grill at our outdoor lounge—your perfect home awaits! Schedule a tour today.",
  "property_long_description": "Welcome to Atlantic on the Boulevard, your tranquil oasis in North Charleston, SC, where modern living meets unparalleled comfort. Our beautifully designed apartment community features a variety of spacious floor plans, including one, two, and three-bedroom options, perfect for every lifestyle. \n\nSafety and convenience are paramount here, with a gated community and 24-hour emergency maintenance at your service. Dive into relaxation at our resort-style pool, enjoy friendly competition on the gaming lawn, or unwind by the outdoor TV lounge with a cozy gas fireplace. For social gatherings or remote work, our expansive clubroom offers plenty of lounge space, while the business center equipped with iMacs is ideal for productivity.\n\nFitness enthusiasts will love our fully-equipped 24-hour fitness center, and for those requiring extra storage, detached garages are available. Our apartments boast modern amenities, including stainless steel appliances, spacious walk-in closets, elegant window coverings, and inviting garden tubs in select units. Enjoy the beauty of wood plank-inspired flooring and the comfort of ceiling fans with decorative lighting in your bedroom. \n\nStep outside onto your private balcony or patio, the perfect spot to savor your morning coffee or evening sunset. With added conveniences like package lockers and gas grilling stations, Atlantic on the Boulevard redefines apartment living.\n\nFind your new home today—browse our availability or schedule a tour to visit our vibrant community! Experience the lifestyle you’ve been dreaming of at Atlantic on the Boulevard.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f66a0-2357-7463-8bdf-5157cd81a1e2.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and tables on the patio.",
    "public_id": "019f66a0-2357-7463-8bdf-5157cd81a1e2",
    "storage_key": "property/6767906449166428/019f66a0-2357-7463-8bdf-5157cd81a1e2.webp",
    "width": 1280,
    "height": 806
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166428/019ffc39-4d3a-73fe-bfc1-ab439e861024.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc39-4d3a-73fe-bfc1-ab439e861024",
    "storage_key": "property/6767906449166428/019ffc39-4d3a-73fe-bfc1-ab439e861024.m4v",
    "thumbnail_key": "property/6767906449166428/019ffc39-4d3a-73fe-bfc1-ab439e861024_thumb.webp",
    "size_bytes": 26752494,
    "classification": "Community",
    "title": "Explore Our Community Amenities: Pool, Clubhouse, and More!",
    "description": "Discover the vibrant lifestyle and exceptional amenities at our apartment community, featuring a sparkling pool, modern clubhouse, and more."
  },
  "property_total_units": "280",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": "34",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.5",
  "property_admin_fee": "200",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security Deposit\n$350-2 Month's Rent\n(refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs are welcome (breed restrictions apply). Maximum of 2 cats and 2 dogs per unit.",
  "property_pet_policy_description": "Cats and dogs are welcome (breed restrictions apply). Maximum of 2 cats and 2 dogs per unit. One-time pet fee: $450 per pet. Monthly pet rent: $20 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://atlanticontheboulevard.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcatlanticontheboulevard",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02ca-2db6-720b-a523-5a3e518fedef.webp",
  "property_primary_logo_media": {
    "alt_text": "Atlantic on the Boulevard logo",
    "public_id": "019d02ca-2db6-720b-a523-5a3e518fedef",
    "storage_key": "property/6767906449166428/019d02ca-2db6-720b-a523-5a3e518fedef.webp",
    "width": 302,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02ca-16a4-7590-9afc-2c49c88d7aa4.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02ca-16a4-7590-9afc-2c49c88d7aa4",
    "storage_key": "property/6767906449166428/019d02ca-16a4-7590-9afc-2c49c88d7aa4.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02ca-49d3-77ba-a96a-5b919c3ed13f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Atlantic on the Boulevard logo",
    "public_id": "019d02ca-49d3-77ba-a96a-5b919c3ed13f",
    "storage_key": "property/6767906449166428/019d02ca-49d3-77ba-a96a-5b919c3ed13f.webp",
    "width": 302,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02ca-5113-7316-9ec6-008653285988.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Atlantic on the Boulevard logo",
    "public_id": "019d02ca-5113-7316-9ec6-008653285988",
    "storage_key": "property/6767906449166428/019d02ca-5113-7316-9ec6-008653285988.webp",
    "width": 302,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "624 - 1434",
  "property_sqft_min": "624",
  "property_sqft_max": "1434",
  "property_price_range": null,
  "property_price_min": "1427",
  "property_price_max": null,
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/atlanticontheboulevard",
  "property_instagram_url": "https://www.instagram.com/atlanticontheave/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJe-lWdXpj_ogRdk2RJqqeWec",
  "property_youtube_url": "https://www.youtube.com/watch?t=8&v=Ojuyy0dpU0c",
  "property_yelp_url": "https://www.yelp.com/biz/atlantic-on-the-avenue-north-charleston",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Atlantic on the Boulevard",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Atlantic on the Boulevard, where modern comfort meets exceptional living in North Charleston, SC. Choose from spacious one, two, or three-bedroom layouts, and enjoy resort-style amenities like a stunning pool, outdoor lounge, and 24-hour fitness center. Elevate your lifestyle—your new home awaits!",
  "property_home_floorplans_blurb": "Welcome to Atlantic on the Boulevard, where contemporary living meets the charm of North Charleston, SC. With a variety of thoughtfully designed floor plans, each apartment home offers a unique blend of comfort and style. Browse our available options today and find your ideal sanctuary right here!",
  "property_home_gallery_blurb": "At Atlantic on the Boulevard in North Charleston, SC, your dream lifestyle awaits. Choose from spacious one, two, or three-bedroom floor plans surrounded by luxurious amenities like a resort-style pool, outdoor lounge with a fireplace, and a state-of-the-art fitness center. Picture yourself living here and elevate your everyday experience!",
  "property_home_neighborhood_blurb": "At Atlantic on the Boulevard in North Charleston, SC, immerse yourself in a vibrant community surrounded by culture and adventure. Enjoy nearby attractions like the Whirlin' Waters Adventure Waterpark, Middleton Place, or the serene Magnolia Plantation and Gardens. Experience local life alongside diverse floor plans designed to suit your lifestyle.",
  "property_home_reviews_blurb": "Welcome to Atlantic on the Boulevard in North Charleston, SC, where vibrant living meets comfort. Our residents rave about the “inviting atmosphere and friendly community.” Curious about their experiences? Dive into our reviews to see how we foster a lifestyle that truly feels like home!",
  "property_neighborhood_blurb": "At Atlantic on the Boulevard in North Charleston, dynamic living meets exceptional convenience. Nestled near parks, cultural sites, and premier educational institutions, our vibrant community offers easy access to Whirlin' Waters Adventure Waterpark, North Charleston Coliseum, and the lush landscapes of Middleton Place. Uncover your new lifestyle today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Atlantic on the Boulevard, where modern living meets resort-style comfort in North Charleston, SC. Enjoy spacious floor plans and top-tier amenities like a stunning pool, gaming lawn, and a stylish outdoor lounge. Elevate your lifestyle with our fully equipped fitness center and luxurious features designed just for you.",
  "property_applynow_blurb": "At Atlantic on the Boulevard in North Charleston, SC, modern living meets comfort. Choose from spacious one, two, or three-bedroom layouts featuring upscale amenities like a resort-style pool, outdoor lounge, and 24-hour fitness center. Embrace a lifestyle of convenience—apply online today and find your perfect home!",
  "property_contactus_blurb": "At Atlantic on the Boulevard in North Charleston, SC, our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom options—offer the perfect blend of comfort and style. Whether you’re seeking a tranquil retreat or a lively gathering space, we have something to suit your lifestyle. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Atlantic on the Boulevard in North Charleston, SC, our diverse floor plans cater to every lifestyle, featuring one, two, and three-bedroom options. Have questions? Our FAQs page offers insights to help you make an informed decision about your future home. Get the answers you need today!",
  "property_floorplans_blurb": "At Atlantic on the Boulevard in North Charleston, SC, we offer a range of thoughtfully designed floor plans—one, two, and three bedrooms—tailored to fit your lifestyle. Each apartment home invites comfort and style. Browse our available options and envision your ideal living space today!",
  "property_gallery_blurb": "At Atlantic on the Boulevard in North Charleston, SC, your ideal lifestyle awaits. Choose from spacious one, two, or three-bedroom floor plans, and immerse yourself in luxurious amenities—from a resort-style pool to a cozy outdoor lounge. Picture yourself enjoying the perfect blend of comfort and community!",
  "property_interactivemap_blurb": "At Atlantic on the Boulevard in North Charleston, SC, our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—are just the beginning. Immerse yourself in luxurious amenities like a resort-style pool, vibrant gaming lawn, and upscale clubroom. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Atlantic on the Boulevard in North Charleston, SC, luxury living meets pet-friendly convenience. Bring your furry friends along—residents can enjoy the company of up to two cats or dogs with a one-time pet fee and minimal monthly rent. Experience vibrant community life nestled in comfort and style!",
  "property_referafriend_blurb": "At Atlantic on the Boulevard in North Charleston, SC, we believe that great friends make great neighbors! With spacious one, two, and three-bedroom floor plans, your ideal home awaits. Enhance your living experience—refer a friend to join our vibrant community today! Your new adventure is just a referral away!",
  "property_residentaccess_blurb": "Welcome to Atlantic on the Boulevard in North Charleston, SC, where our diverse floor plans—ranging from one to three bedrooms—cater to your lifestyle. Access your resident portal now for hassle-free rent payments, quick maintenance requests, and a community designed with you in mind. Your comfort awaits!",
  "property_reviews_blurb": "At Atlantic on the Boulevard in North Charleston, SC, residents rave about the vibrant community and top-notch amenities. One highlighted review states, “The sense of community here is unmatched!” Dive into our reviews and see what makes living here truly exceptional! ",
  "property_created_at": "1759782545184",
  "property_scheduletour_blurb": "At Atlantic on the Boulevard in North Charleston, SC, vibrant living awaits you. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that perfectly match your lifestyle. Want to know more? Schedule a tour and see why our residents love calling this community home!",
  "property_thankyou_blurb": "Thank you for reaching out to Atlantic on the Boulevard in vibrant North Charleston, SC! Your interest in our diverse one, two, and three-bedroom floor plans is appreciated. A team member will connect with you shortly to help make your apartment dreams a reality. Stay tuned for the next steps!",
  "property_virtualtours_blurb": "At Atlantic on the Boulevard in North Charleston, SC, choose from spacious one, two, or three-bedroom floor plans designed for modern living. Embrace the charm of our community with a virtual tour that highlights everything from stylish interiors to inviting amenities. Experience your future home today—take the tour!",
  "property_copyright": "2025 All Rights Reserved. Atlantic on the Boulevard",
  "property_seo_title_home": "Apartments in North Charleston | Atlantic on the Boulevard",
  "property_seo_description_home": "Atlantic on the Boulevard is a luxury apartment living Community with pet-friendly 1, 2 & 3-Bedroom apts for rent in North Charleston, SC. Contact us today!",
  "property_seo_title_floorplans": "Floor Plans | Luxury 1, 2 & 3-Bedroom Apts in N. Charleston",
  "property_seo_description_floorplans": "Explore 1, 2 & 3-Bedroom apts at Atlantic on the Boulevard in North Charleston. A resort style swimming pool, a business center and a fitness center await.",
  "property_seo_title_amenities": "Amenities | North Charleston Apts With Resort Style Pools",
  "property_seo_description_amenities": "Enjoy walk in closetss and in unit washeres and dryers at Atlantic on the Boulevard in North Charleston, SC. Pet-friendly living made easy.",
  "property_seo_title_gallery": "Gallery | Luxury Apartments For Rent in North Charleston, SC",
  "property_seo_description_gallery": "View photos of Atlantic on the Boulevard in North Charleston, SC. See stylish floor plans, luxury amenities, and pet-friendly community spaces.",
  "property_seo_title_virtualtours": "Virtual Tour | Luxury Pet-Friendly Apts in North Charleston",
  "property_seo_description_virtualtours": "Embark on a virtual journey at Atlantic on the Boulevard! Explore our pet-friendly 1, 2 & 3-Bedroom apts in North Charleston, SC, through our virtual tours.",
  "property_seo_title_interactivemap": "Interactive Map | Atlantic on the Boulevard Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Atlantic on the Boulevard in North Charleston, SC. Browse our spacious floor plans and amenities using our interactive map today!",
  "property_seo_title_neighborhood": "Neighborhood | Apts Near Charleston International Airport",
  "property_seo_description_neighborhood": "Live close to Charleston International Airport and Downtown Charleston at Atlantic on the Boulevard with luxury apts designed for your comfort and convenience.",
  "property_seo_title_contact": "Contact Us | Apartments Downtown Charleston",
  "property_seo_description_contact": "Contact Atlantic on the Boulevard today to schedule a tour. Discover 1, 2 & 3-Bedroom apts with modern features in North Charleston with modern kitchens.",
  "property_seo_title_faqs": "FAQs | Apartments in North Charleston, SC",
  "property_seo_description_faqs": "Uncover answers to your top questions at Atlantic on the Boulevard! From amenities to floor plans, learn why our North Charleston community feels like home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Charleston, SC",
  "property_seo_description_reviews": "Discover life at Atlantic on the Boulevard, North Charleston! Enjoy spacious layouts, luxury amenities, and a vibrant community vibe. Read more!",
  "property_seo_title_applynow": "Apply Now | 2 Bedroom Apartments in North Charleston, SC",
  "property_seo_description_applynow": "Ready to make Atlantic on the Boulevard your new home? Apply online for our 1, 2 & 3-Bedroom apts in North Charleston and start your journey today!",
  "property_seo_title_residentaccess": "Resident Access | Luxury One Bedroom Units",
  "property_seo_description_residentaccess": "At Atlantic on the Boulevard, our resident portal offers seamless 24/7 access, simplifying maintenance requests and online rent payments for your convenience.",
  "property_seo_title_referafriend": "Refer A Friend | Atlantic on the Boulevard",
  "property_seo_description_referafriend": "Refer a friend to Atlantic on the Boulevard in North Charleston, SC, and enjoy the perks of great neighbors. Share the warmth of community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments With 24 Hour Fitness Center",
  "property_seo_description_scheduletour": "Excited to explore Atlantic on the Boulevard in person? Arrange a tour to discover our amenities and open-concept apartment designs in North Charleston, SC!",
  "property_seo_title_privacy": "Privacy Policy | Atlantic on the Boulevard",
  "property_seo_description_privacy": "At Atlantic on the Boulevard, safeguarding your privacy is our top priority while offering exceptional apartment living.",
  "property_seo_title_accessibility": "Website Accessibility | Atlantic on the Boulevard",
  "property_seo_description_accessibility": "At Atlantic on the Boulevard in North Charleston, SC, we prioritize digital inclusion and accessibility for everyone. Join us and stay connected!",
  "property_seo_title_sitemap": "Sitemap | Atlantic on the Boulevard",
  "property_seo_description_sitemap": "Navigate your way to comfort and style at Atlantic on the Boulevard in North Charleston. Check out our sitemap for a seamless living experience!",
  "property_seo_title_thankyou": "Thank You | Lease Atlantic on the Boulevard Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in Atlantic on the Boulevard Apartments. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pet Policy | 1 Bedroom Apartments in North Charleston, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786643045603",
  "amenities": [
    {
      "id": "custom_e1c5f3a0-87e7-494e-af8b-6ffbf5c3eb98",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4ca75c30-3838-41f1-b7ca-d60090fba524",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_464e3070-d9a6-4d66-a102-6e561ad916e9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Style Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_efabd171-249e-40cf-b09f-f2db056b6fdd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Gaming Lawn",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_bc033c6c-82c2-41f7-98b0-8893dfa7badf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Pool Area Lounge with TV & Ping-pong Table",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_432f9ca5-2a46-4684-a2cd-8ffa86bb0963",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Clubroom With Plenty of Lounge Space",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1090684c-727d-47ed-8b03-579822384b86",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center with iMacs",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d0d850e5-81f0-4c29-afe6-39a9761bd5ef",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Grilling Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_31ec4c76-99f4-46db-9383-d96dede9c2af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_839251dd-86d1-474c-a717-8bd47bedebb2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Elevators",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_0dd0c9f0-196c-4f74-916b-c57909fa508c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1b2e2a8b-00d2-4f98-b2bb-2dfbd04a770e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Walk In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_61a72995-cbe5-4b35-afab-ebc0c38f2ff8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d9e6620b-bba2-43ad-9c8e-fa5b9ebde911",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cd62998b-6c41-40f9-9a96-c9a8ed7a01cb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b7447a4c-c10f-4f31-9602-9d6b70e7fa0b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Garden Tub*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_04389ca3-f16e-4ded-bee7-f219bedd7844",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floorplans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a48e1c48-f84d-4362-ae35-219d42dd1816",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Balconies and Patios",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_01b34c04-1059-4426-b5c3-7c144b53551c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Carpet in Bedrooms*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_bf073d03-a24e-4e56-ac3d-76d30e99dc42",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Plank Inspired Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_68b2e371-f932-4c00-817c-28053368b718",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Bedroom Ceiling Fans With Decorative Lighting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e6ae8025-2153-448e-b1b4-0c8f4ff62466",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Kitchens",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9e43fe6a-5048-4715-95f4-094d94a8ad27",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Islands*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cefd9c38-4041-4f6a-bcbf-c6ef63ea44d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Peninsulas*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2a65b997-492c-462b-bb79-200a64b95318",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-f4de-7143-9de7-87df488bd85c.webp",
      "image_media": {
        "alt_text": "Atlantic on the Boulevard monument sign and apartment building exterior",
        "public_id": "01a010c1-f4de-7143-9de7-87df488bd85c",
        "storage_key": "property/6767906449166428/01a010c1-f4de-7143-9de7-87df488bd85c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Atlantic on the Boulevard, a premier apartment community offering comfortable living and excellent amenities. Explore our beautiful grounds and modern residences.",
      "link": "",
      "alt_text": "Atlantic on the Boulevard monument sign and apartment building exterior",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_edb02789-ff91-4500-9396-f3d529d62009",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-e0df-7332-8233-a7af506549ff.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building complex with a central clubhouse and ample parking at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-e0df-7332-8233-a7af506549ff",
        "storage_key": "property/6767906449166428/01a010c1-e0df-7332-8233-a7af506549ff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover modern living at our apartment complex, featuring a beautifully designed clubhouse, lush landscaping, and convenient parking. Experience the best of community living.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building complex with a central clubhouse and ample parking at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_477b2df7-fa27-44a8-9c6c-ba655a3ec9b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-ea34-778b-a88d-f563d57244d4.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and surrounding greenery at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-ea34-778b-a88d-f563d57244d4",
        "storage_key": "property/6767906449166428/01a010c1-ea34-778b-a88d-f563d57244d4.webp",
        "width": 3072,
        "height": 1715
      },
      "title": "Community",
      "description": "Modern apartment complex featuring multiple buildings, a swimming pool, lush landscaping, and ample parking.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a pool and surrounding greenery at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6dc9523c-2942-4df4-af77-091c1b5692f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-f39c-710d-b4f2-c6f756405eaa.webp",
      "image_media": {
        "alt_text": "Modern co-working space with comfortable seating, computers, and a nature-themed mural at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-f39c-710d-b4f2-c6f756405eaa",
        "storage_key": "property/6767906449166428/01a010c1-f39c-710d-b4f2-c6f756405eaa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our stylish co-working space, perfect for remote work or study. Featuring comfortable seating, computers, and inspiring decor.",
      "link": "",
      "alt_text": "Modern co-working space with comfortable seating, computers, and a nature-themed mural at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_451ea5a6-f245-4207-9f6b-dec4f2b15085",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-f341-73bf-951a-8bfaf5cd0ad7.webp",
      "image_media": {
        "alt_text": "Community dining area with large wooden table and chairs, view of pool through large windows.",
        "public_id": "01a010c1-f341-73bf-951a-8bfaf5cd0ad7",
        "storage_key": "property/6767906449166428/01a010c1-f341-73bf-951a-8bfaf5cd0ad7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather with neighbors in the stylish community dining area, featuring a large wooden table and chairs. Enjoy the natural light and view of the outdoor pool.",
      "link": "",
      "alt_text": "Community dining area with large wooden table and chairs, view of pool through large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8cbab081-b284-4229-8bb0-8276a340c0e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-f39d-71fd-ab06-c97ff6492527.webp",
      "image_media": {
        "alt_text": "Modern lounge area with sofas, armchairs, a coffee table, and a decorative shelving unit.",
        "public_id": "01a010c1-f39d-71fd-ab06-c97ff6492527",
        "storage_key": "property/6767906449166428/01a010c1-f39d-71fd-ab06-c97ff6492527.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring comfortable seating and stylish decor.",
      "link": "",
      "alt_text": "Modern lounge area with sofas, armchairs, a coffee table, and a decorative shelving unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b8346bb4-23fa-47f0-9395-5f082e523c1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-a0ef-717a-905c-e0040bb9fe81.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, weight machines, and free weights, overlooking the pool area at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-a0ef-717a-905c-e0040bb9fe81",
        "storage_key": "property/6767906449166428/01a010c1-a0ef-717a-905c-e0040bb9fe81.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring top-of-the-line cardio equipment and strength training machines. Enjoy a workout with a view of the sparkling pool.",
      "link": "",
      "alt_text": "Modern apartment gym with treadmills, weight machines, and free weights, overlooking the pool area at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c26379d5-2156-4fb2-863a-43bf45c36093",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-aaed-70bb-80fc-fb031c96ab6e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to apartment buildings at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-aaed-70bb-80fc-fb031c96ab6e",
        "storage_key": "property/6767906449166428/01a010c1-aaed-70bb-80fc-fb031c96ab6e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and vibrant umbrellas. Adjacent BBQ grills and covered seating area are perfect for outdoor entertaining.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to apartment buildings at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f129655-39db-453a-aea7-262fe0dce61a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-bb66-77f7-a396-a587a50e2181.webp",
      "image_media": {
        "alt_text": "Apartment building courtyard with a swimming pool and lounge chairs.",
        "public_id": "01a010c1-bb66-77f7-a396-a587a50e2181",
        "storage_key": "property/6767906449166428/01a010c1-bb66-77f7-a396-a587a50e2181.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Enjoy the sun and the serene atmosphere of our beautiful community.",
      "link": "",
      "alt_text": "Apartment building courtyard with a swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab095416-c9f4-43e0-9cc9-42c51895a9a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-c4d8-71bc-b3e4-cc556a029881.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "01a010c1-c4d8-71bc-b3e4-cc556a029881",
        "storage_key": "property/6767906449166428/01a010c1-c4d8-71bc-b3e4-cc556a029881.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3820dc59-3b37-44f4-8b4b-a219e4558694",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f777d-6fb1-7451-9837-4bcbffb65039.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with built-in grills and string lights at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "019f777d-6fb1-7451-9837-4bcbffb65039",
        "storage_key": "property/6767906449166428/019f777d-6fb1-7451-9837-4bcbffb65039.webp",
        "width": 1280,
        "height": 820
      },
      "title": "Community",
      "description": "Enjoy our outdoor grilling area, perfect for hosting friends and family. Features built-in grills and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor grilling area with built-in grills and string lights at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a22c10f-4903-4903-aadd-fa9948e38353",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-a2ba-72f5-ae20-a792386c9442.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and pool area with grills, seating, and lounge chairs.",
        "public_id": "01a010c1-a2ba-72f5-ae20-a792386c9442",
        "storage_key": "property/6767906449166428/01a010c1-a2ba-72f5-ae20-a792386c9442.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and relaxation by the pool at our apartment community.",
      "link": "",
      "alt_text": "Outdoor kitchen and pool area with grills, seating, and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1d5a5614-8f79-4833-81dd-b9beae80155e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-9d9e-775b-8314-b5bbe95d1aa2.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge with ping pong table, fireplace, and TV overlooking pool  at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-9d9e-775b-8314-b5bbe95d1aa2",
        "storage_key": "property/6767906449166428/01a010c1-9d9e-775b-8314-b5bbe95d1aa2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this covered lounge featuring a ping pong table, fireplace, and TV, perfect for relaxation and entertainment by the pool.",
      "link": "",
      "alt_text": "Covered outdoor lounge with ping pong table, fireplace, and TV overlooking pool  at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0801c8e8-4d7f-49dc-a2d8-291e866ad223",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-c705-7204-a1b4-2c6c4eccffbe.webp",
      "image_media": {
        "alt_text": "Fenced dog park area with grass and a blue shade sail, adjacent to apartment buildings.",
        "public_id": "01a010c1-c705-7204-a1b4-2c6c4eccffbe",
        "storage_key": "property/6767906449166428/01a010c1-c705-7204-a1b4-2c6c4eccffbe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced-in dog park, perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Fenced dog park area with grass and a blue shade sail, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5452bd8f-761f-48da-8b82-5bcba684322e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-b9ff-751b-a1d9-fe7b74bd3d91.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with bar stools at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-b9ff-751b-a1d9-fe7b74bd3d91",
        "storage_key": "property/6767906449166428/01a010c1-b9ff-751b-a1d9-fe7b74bd3d91.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, stainless steel appliances, granite countertops, and a large island perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with bar stools at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e1a96297-c987-45c3-a33b-a92da6309121",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-ba37-700e-a5f9-a0bbaa3087f7.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with dark wood cabinets, stainless steel appliances, and a dining table with green velvet chairs at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-ba37-700e-a5f9-a0bbaa3087f7",
        "storage_key": "property/6767906449166428/01a010c1-ba37-700e-a5f9-a0bbaa3087f7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this stylish kitchen, featuring dark wood cabinetry, sleek countertops, and a bright dining area with comfortable seating. Perfect for entertaining or everyday meals.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with dark wood cabinets, stainless steel appliances, and a dining table with green velvet chairs at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5120c570-dd84-4031-b0b7-7145eaff21a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-ba3c-716f-8f70-accd3546a135.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with large windows, ceiling fan, and stylish furniture at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-ba3c-716f-8f70-accd3546a135",
        "storage_key": "property/6767906449166428/01a010c1-ba3c-716f-8f70-accd3546a135.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious living and dining area featuring a sectional sofa, elegant dining set, and ample natural light. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living and dining area with large windows, ceiling fan, and stylish furniture at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1caacbb-8e9b-4c38-be0f-18f41e0bad60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-c985-75ba-b705-2b4107290180.webp",
      "image_media": {
        "alt_text": "Bright bedroom with a queen-size bed, white linens, and teal accent pillows. Features a ceiling fan and a large window with a view of palm trees and buildings at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-c985-75ba-b705-2b4107290180",
        "storage_key": "property/6767906449166428/01a010c1-c985-75ba-b705-2b4107290180.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom, complete with a comfortable queen-size bed and ample natural light. The room features a ceiling fan for added comfort and a large window offering views of the surrounding landscape.",
      "link": "",
      "alt_text": "Bright bedroom with a queen-size bed, white linens, and teal accent pillows. Features a ceiling fan and a large window with a view of palm trees and buildings at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd45e493-ed7f-4034-b48c-6e6901cb2418",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-cc10-716a-9447-5227a1e8aa79.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark wood vanity, white countertop, and stainless steel fixtures at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-cc10-716a-9447-5227a1e8aa79",
        "storage_key": "property/6767906449166428/01a010c1-cc10-716a-9447-5227a1e8aa79.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity, modern lighting, and a bathtub with a white shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with dark wood vanity, white countertop, and stainless steel fixtures at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2e369e2-0329-4920-942c-7f9d277cfd46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-ca5a-709f-8397-93cb4ef9b116.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, ceiling fan, and large window overlooking a green backyard at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-ca5a-709f-8397-93cb4ef9b116",
        "storage_key": "property/6767906449166428/01a010c1-ca5a-709f-8397-93cb4ef9b116.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully appointed bedroom, featuring a plush king-size bed, modern ceiling fan, and abundant natural light from a large window.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, ceiling fan, and large window overlooking a green backyard at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11335ac1-9075-4218-ad95-2805dc065d5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/01a010c1-d1fd-7080-b918-77225db6cdd7.webp",
      "image_media": {
        "alt_text": "Balcony with seating and table overlooking parking lot at Atlantic on the Boulevard in North Charleston, SC.",
        "public_id": "01a010c1-d1fd-7080-b918-77225db6cdd7",
        "storage_key": "property/6767906449166428/01a010c1-d1fd-7080-b918-77225db6cdd7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with seating and a table.",
      "link": "",
      "alt_text": "Balcony with seating and table overlooking parking lot at Atlantic on the Boulevard in North Charleston, SC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_887691f7-0a44-4bf2-a213-2c6ce2b5b816",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "XscapeWorks",
      "poi_type": "Entertainment",
      "poi_address": "2430 Air Park Rd, North Charleston, SC 29406, USA",
      "poi_short_description": "Scary escape room featuring live scare actors alongside zombies, ghosts and creepier scenarios.",
      "poi_long_description": "People say this escape room center offers a unique and immersive experience with challenging puzzles, interactive tasks, and engaging storylines. They highlight the fun, elaborate, and well-thought-out rooms, as well as the impressive attention to detail, special effects, and animatronics. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ09kDI_tj_ogRJZGZXIwCJDo/photos/AcnlKN3aF4yEw7lELcP15e7nLIm9bGQUdJiSL1-aDXp7fNXwU-1Yd8wx4Es7-T67dIdd54-aYn4fFqvMh4FIvi5ZRCwXK9mdo78LErwkgjskO1a8O6d4HiUyJ-LoPjwBxve4o9qD29p26fjB5sg_T2GW0pAlSKcZybZFrGHGl_gWGI25ASvw47-6AgXQr4fQRnCDuJqXyrtDhE3xJp4gh7ehvK8DTwYJ1KffqYSsBcmfGAOc8vrZQA0Z0DWlEzmU7-fwoi3oLCJpGPYIybUD5MknxYDAdF5z9jNMO2dCkDPmvozAPg/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1920&maxHeightPx=1080",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.xscapeworks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4189476355233648933&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "xscapeworks",
      "poi_latitude": "32.8941995",
      "poi_longitude": "-80.0219231",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-764-9405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09kDI_tj_ogRJZGZXIwCJDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_3e735cc4-09e5-4608-b4ef-023451804d7b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Flight Adventure Park Charleston",
      "poi_type": "Entertainment",
      "poi_address": "8551 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Trampoline park for all ages offering an array of jump options, a ninja warrior course and dodgeball.",
      "poi_long_description": "People say this recreation center offers a variety of fun activities, including a sports court, trampolines, and a ninja warrior course. They highlight the great value, especially with the monthly membership, and the vibrant, energetic atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJryQoZXBh_ogROM0QMO9Ja9o/photos/AcnlKN1ljg699AzdkS8srQ-3ZJlyeyiQleWM76JlkiYbAOYFRBWFeCLWGDhwWVa0sGCV9ohsqYoUR823oCgYUviEwUDtLxq3ZNEU8MaYnYGX0LmJ86f9Ij3DldfQRHy5_iCfYUTr5QPduW7Nhjs46R6qfT868McmgmzLWHfvWwb0NPl0MzhsEfx-btL6sqT44q8mbbb8YL8PQzC7hE6FEkeE_M9j_-vEGzcilRS9qr4aWb7n-AmqIfZsO37LfUWHYZrjwUUBzcc7PEl3W5uUcFNQmamwJiaKmSbMKALYnWWLXiusOx4hbNMX96unNNUdpuFlnOAumrUP9Vvy4s8I-rsAkMJqwA9wvdGezgHlH7W07aJ_tAadt3514PJHTjT56DMUu0RCs4Aam944PlaJnvTqXq6AN2lVoBS2ygsNG6ZXzGM/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://flightadventurepark.com/charleston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15738754614428749112&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "flight-adventure-park-charleston",
      "poi_latitude": "32.9619082",
      "poi_longitude": "-80.0445572",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-414-7411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryQoZXBh_ogROM0QMO9Ja9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_337af997-ab57-4aca-aa5a-724f95b284e7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Northwoods Stadium Cinema",
      "poi_type": "Entertainment",
      "poi_address": "2181 Northwoods Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "Spacious movie theater showing mainstream first-run films, including 3D features.",
      "poi_long_description": "People say this movie theater offers comfortable, reclining seats and a good movie-watching experience. They also highlight the unbeatable prices for tickets and concessions, and the friendly staff.\n\nSome reviews mention the theater can be outdated.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJI-fFW9Bj_ogRWfpxqxq2coY/photos/AcnlKN1V6w_HPnJdtV9eB4fHbXVt7p_BRPGYh6ECP60sz29VPSvdw-SexMyYVwtDYlsAyGemFv-4hZwDrXcUTbPu5X0g-TEU5TJ5mMrVxv8flD37n5hHTTN7VLZT_oit8jNA_9YWJpN_MineDaP8452_SioorRq_zu1MXkTEpWfNkOL5keNUpFiw0vINyZMme5bdGgui2rcvo5MAhKRQm4fIsZ1atzeXqZ0TFJnSEeRBUx9pbDyd1rJlWkJEiO4tLhE1XM_iDpo9ZCVOO2BbKIL4Mx7IclXcvqlTCGMpik1jmmVKtw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=640&maxHeightPx=480",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.southeastcinemas.com/movie-theater/northwoodsstadiumcinema",
      "poi_directions_map_url": "https://maps.google.com/?cid=9688005974089136729&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwoods-stadium-cinema",
      "poi_latitude": "32.9403158",
      "poi_longitude": "-80.0440713",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-300-4190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02ca-0021-7143-8d53-fd37052bb906.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-0021-7143-8d53-fd37052bb906",
        "storage_key": "property/6767906449166428/019d02ca-0021-7143-8d53-fd37052bb906.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-fFW9Bj_ogRWfpxqxq2coY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9adf62d1-4bbb-4467-95fc-1a3fd1cac5a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Topgolf Charleston",
      "poi_type": "Entertainment",
      "poi_address": "5000 Topgolf Wy, North Charleston, SC 29418, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun golf games, delicious food, and strong drinks. They also highlight the lively atmosphere, comfortable bays, and friendly service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJgzTeIedj_ogRKSClP0RCWUQ/photos/AcnlKN1PcR3tfX2M41hw1Lf0cN26CvCz7amwJoKWHVe1YR66UcSQwT21ldXbP2f-siAdTlM9tBm5kUPc2Sqs_g9hytPgTf1LzBH-Iy8Zw96QV4vjEIeswlzD5VMZNCPu9oIk7HGX80zRCM7qGmld1GHzut-HwPmGWajOa33P1LtbCCHpjT2wL3kls7QmDg75L-rORtn_OJjYljsybtFPe7pxFNZOD06GLhuSiosCRBDrjp399M5j_lczUPXLr5fQQ7P6vhTFVLXUSfRd42Vs4JrQh51PFlvwrAfikJPJ8ItZlRUusgESuIVsyCFhWfQgsLYFKT0h-tzgb6bhjsw44IFFcM1dvw3fSsaVVmXcsj5EIM6I2RzyNSbVRpeJKZ8AFsEkKhpl47F3p4tqAra5eM2mw-FtsmUxKu1joo1P0cdBb3E/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4080&maxHeightPx=3072",
      "poi_featured_image_media": null,
      "poi_business_url": "https://topgolf.com/us/charleston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4925040528399343657&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "topgolf-charleston",
      "poi_latitude": "32.869225",
      "poi_longitude": "-80.016504",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 854-895-4034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-4bc138403558",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzTeIedj_ogRKSClP0RCWUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_aeb2112e-0f65-426f-bfa9-6f208cf6231c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "At Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "6185 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Indoor and outdoor furniture shop with a vast assortment of home decor pieces.",
      "poi_long_description": "People say this home goods store offers a huge selection of items, including seasonal and holiday decor. They also highlight the great prices and friendly, helpful staff.\n\nOther reviews mention the store can be overwhelming.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJB843pZ1j_ogR3ncO2PIu5-8/photos/AcnlKN3DYuKBfsClWTID26GcSAElO9GnynAJ0UNi8tFbiwlzabx3JEvo62_a6-aakmyGw1Zpr2z8iUg9ttPOx1sS7YRZHyH5taNvHpUqcqKIN7aPRNAb1hS4pGXEE6RN_yNuVT7tnu4wRuG3LakBx4g1M7eRZCwJ1d0WndAcXgj05O0TR3Hkyhf2Bx5x8FvEB-Z35G3ry-Y3cgLVGD0fweXOYm77LxszZ8P9MXHEcpQ-nOHXYCzcwo-b29FSwn2KZQ3MclZw8IgrLTN8HwlXQFcJRl9s5SY2GsD8qqx0DQAVyMHA7g/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1600&maxHeightPx=900",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.athome.com/store/south-carolina-charleston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17286837315226728414&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "at-home",
      "poi_latitude": "32.9063996",
      "poi_longitude": "-80.0243421",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-724-6970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a",
        "storage_key": "property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB843pZ1j_ogR3ncO2PIu5-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_6a4d4e7e-4f99-4143-8e2c-6db418fbabf8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Old Navy",
      "poi_type": "Shopping & Retail",
      "poi_address": "7620 Rivers Ave Suite 210, North Charleston, SC 29406, USA",
      "poi_short_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_long_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ-dlsdttj_ogR9zOwedCJv9U/photos/AcnlKN0OZGkgA5K6h0KlEAO7fBBUPI8vLq9K5MXnzi-R3UgqS0HNqn1I3Qu0BSs0xlwQHSd5tIheT-b0dqNud3kkhiYonz-XZSBMtiyjLtasrLHptfSepepfc76f06287npY4U8Ua28lQJCfez00Y_Moy8NT2Hq0PydLDBPmbmVYkFOF1mCj0j24aQNZE3rJ7O_pjjaF0qFoM-B3fxNUzJE2QtHnXZ_VKxANxHPFAPDZYDwvSkE6lN673_qvY40UESHOVhmOSLR-OZuaMeExGjSQic0JobxIQD3JdhWsG2eqDiAqZbSRiIJvty61DUuRE1vnoZ-7UZ4NgEHr5sv8VcuLE12LV8gWhxrJ4R2J6JASjrsguAFaKAeFrf2sW761NddWJhaqXQqo5PWKtwyy9XavtUsFTlSobyeUCneiSESRDsQvm9ms/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1600&maxHeightPx=1200",
      "poi_featured_image_media": null,
      "poi_business_url": "https://oldnavy.gap.com/stores/sc/northcharleston/oldnavy-5320.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15402180779118179319&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-navy",
      "poi_latitude": "32.9420949",
      "poi_longitude": "-80.0377068",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-628-5795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a",
        "storage_key": "property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-dlsdttj_ogR9zOwedCJv9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_e8ddb572-6eda-4ab4-b97d-9b11529bf1da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "7250 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products, including fresh produce, snacks, clothing, toiletries, and travel essentials, and is clean, bright, and well-organized.\n\nOther reviews mention the service can be unhelpful and the staff can be impolite.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJX9bcwMNj_ogRwEu2BM0xX8c/photos/AcnlKN0noE0EW2hI3odXygY993pgohUvaASHNMbI1fXQBDQPey7A1H4yuchAdBq-ozoLJ-9JiVoVLsf8IQAbtEdVxgg7iBzx6l2hqlMdbRRjCNKwgZ8Zv6LUCoTMdN6lmDByMuyBgzKFpM5X1t_vUcO2KzcmMK0VfdcjEaDKepl_UKXmthtDeo7QOi-7p4OJKbLImObW56TBJpJE5QI1yQh1qJRUyYUNL3j707oFzXGfirlMA1ruxXxPx1i9XBBRaSMlri3VO9X7Hvlyym6WWpkiy0wHARf6Ohr8nPUPTKkUcTIgnZvCZ3HHhJdAewGPHggqNjEtFfxNliFMrO69lWp_8GwT_W8vrohsGeZqwNYSYIImb9W6j6yq77Lb4x7NTFe6rd4NM3XHqIErFFXUwDvngqWNV3HEY1APxc6Qgl8iiLM/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=2448&maxHeightPx=3264",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.target.com/sl/north-charleston/1829",
      "poi_directions_map_url": "https://maps.google.com/?cid=14366256092952284096&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.9354172",
      "poi_longitude": "-80.03604709999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-553-4691",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a",
        "storage_key": "property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX9bcwMNj_ogRwEu2BM0xX8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_66bec5ff-7454-4e3f-a1b0-1876c96dc547",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2130 Melnick Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and appetizers, and is known for its warm rolls and mozzarella sticks. They also highlight the fun, homey vibe, and the attentive service from the staff.\n\nSome reviews mention there can be a long wait time.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJcRsQenph_ogRN1d3OCaMV9M/photos/AcnlKN2lFgSWIWyM5AAq1ri2Waxu1COTDDpj6xJVTZ8thkSKExq0tbGw4C_rMlnG7Z5FwLe11Dewi4KWKZXD1VXDkhK2dGXtOkt7jn-7bfdlvD-tKjkJSP1peIjUzcz4NoDs8MTg42QvQc83-Os_q-NdUuP0m5YfpVZCn_txC8FRCAaguE_gn5O9714pZ4NNd6FOLLDk0PxBheulLQQk-BSfiN5hMaPlwwSDmvhwXrlVEmwk9bWERQkJU5wJb5jBFLshzv--scPg-UyLMMCLn0eWa_GgIkxeKObJIEvsdnY7KXxppwR9bY-FZuf5i-0x06GEK_T_fYIViX-ivBzfsJXxZU1MFba1EGSbOB1NVnwGakce2VkvGBrCAe-EfE_pEvhxw_of5BLb2EuZ4-Odk11pSC4GDQSxuZPiIY2kZDBmpjlvJA1w/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1079&maxHeightPx=555",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.texasroadhouse.com/locations/south-carolina/n-charleston?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=15228794760760612663&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.9618103",
      "poi_longitude": "-80.0457321",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-569-7556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-4bc138403558",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRsQenph_ogRN1d3OCaMV9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_933ffe93-d47c-4944-9796-1826349314cc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "The Grit Counter - North Charleston",
      "poi_type": "Restaurants",
      "poi_address": "3438 W Montague Ave, North Charleston, SC 29418, USA",
      "poi_short_description": "Homestyle grits bowls and other breakfast eats like waffles and biscuits.",
      "poi_long_description": "People say this restaurant serves delicious grit bowls, shrimp and grits, and chicken and waffles. They highlight the generous portions, reasonable prices, and fun atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ92l-OmJj_ogR6yu73GBVWkU/photos/AcnlKN2Z8FTbwW6jBNzLDy_upXaR60on2qJ9XLlfwYWtEQVb3eiNUMSKNc--kaecLljSRjm3ap5Bs5mCdSb19fnAxYY4tR6T9ikJON6nYKT_ZY3apHmk-AYdUkDZ0cAtpUfshPgXmT3JodJyQ6OtjV4LV04brDgX-hi81f2DrO8BX3OmyKyyIkPboTYbLmmhjTRBtZ2gFHoH7Z5fpjuSgv4LfELseRUB3hGnh49Dbc499iYxU6HOWUj_blRb-SHbqFTApYAYPV6K0_odNALvdP7UXwuDH2QfXxzJ0r5HX7JNf4PTzw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=800&maxHeightPx=800",
      "poi_featured_image_media": null,
      "poi_business_url": "http://gritcounter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4997400611029461995&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-grit-counter---north-charleston",
      "poi_latitude": "32.8638763",
      "poi_longitude": "-80.0228652",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 854-895-4748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-4bc138403558",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ92l-OmJj_ogR6yu73GBVWkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4a773c64-6472-422b-931f-d0eb61400ae0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "843 Korean BBQ & Sushi House",
      "poi_type": "Restaurants",
      "poi_address": "6601 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Casual eatery offering BBQ beef, pork & veggies cooked on tabletop grills, plus sushi.",
      "poi_long_description": "People say this Korean barbecue restaurant offers delicious bulgogi, sushi, and all-you-can-eat options. They also highlight the fun and engaging atmosphere, and the friendly, attentive service.\n\nOther reviews mention the drinks can be slow.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJmx7Jnpdj_ogRhMM49bt9Pqc/photos/AcnlKN2mpqOD6s4PNUf6R-3xLddP0-gCpcNhHL12TMFLswmNeJ-bRjBpV_DtFQc0K9F60wNDbRhA0YRojA9Yh126bMRmnd0_h-zZYgVoFS60ExGtxRbl2zdNfLhmOK7hLAGWTu4CPsOsn3GXef6Ip8rgAizmo22FTYg5ivdVHRFIqqoFB3HpGFeWR_G-0Ghw6utvKm0_mJAjHeN4pcx-shsDvfD7iKBfwPVpI8rt7fv1yuX-4NBeWmVaQ5p2shi5GmQk-ZVHIdRnPfM18HKaHmHQGvoM15gs8DC4cRqtSi3AMT4Tow/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.843koreanbbq.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12051207899116520324&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "843-korean-bbq--sushi-house",
      "poi_latitude": "32.9171395",
      "poi_longitude": "-80.0283671",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-764-9578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-4bc138403558",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmx7Jnpdj_ogRhMM49bt9Pqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_d738498b-892c-44c7-a17b-a413e7e8f387",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Tiki Taco",
      "poi_type": "Restaurants",
      "poi_address": "7089 Rivers Ave Ste A, North Charleston, SC 29406, USA",
      "poi_short_description": "Tacos, burritos & other Mexican staples offered in an informal venue with bright tropical decor.",
      "poi_long_description": "People say this Mexican restaurant serves authentic and flavorful tacos, quesabirria, and other dishes. They also highlight the reasonable prices and the Taco Tuesday special.\n\nOther reviews mention the seating can be limited.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJhfUXnMBj_ogRKXjQoHHvfp4/photos/AcnlKN2mdP3sbZrTpieScRHCmXnBemOGG9pXp9EdXQqNcjmxzmWWL5OzJU_BYWurKCWIvV6eKB6NHy8wCATbruE1OHn8Dn0yH7KrZBSMILm1s7lcc_PZPiu4niPWYmCxHmXuMq7pO2g2LEzRic3mb9TxgpcjAhDYiFQjZp_JJUAa7dm0kn6zhoK7e59e4fInwLbNgNhwiCo2V04noB6no5Fwiku-QuRaDCUs7ixakPsfyR5fsB24g4SqjEhWZezm70zHjI2ueQnnugvmdD5mXdkntYTA8EBmsZOJXtgGGMinJTmtg8OlnamAB6IXk0ft3DnwHkEdkgIODVUNIvX9H4rERpkRPG0vAsFKqlNas7wUrLjWGiPeq_DNxNZ5gCFlqNVMnfGjgZ5SZemizu2iqkv_AuBxJNrP4Y3yt9dkSPImOHNRBg/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3024&maxHeightPx=4032",
      "poi_featured_image_media": null,
      "poi_business_url": "http://rivers.itstikitimeyall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11420828976366516265&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tiki-taco",
      "poi_latitude": "32.9278207",
      "poi_longitude": "-80.0349337",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 854-999-1852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-4bc138403558",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhfUXnMBj_ogRKXjQoHHvfp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_eccc5d93-ecd7-4fb2-bfc0-8d9d5dba7ad1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Bahama Breeze",
      "poi_type": "Restaurants",
      "poi_address": "7811 Rivers Ave, Charleston, SC 29406, USA",
      "poi_short_description": "Laid-back chain eatery featuring Caribbean entrees & tropical cocktails amid beachy decor.",
      "poi_long_description": "Diners say this Caribbean restaurant serves up delicious coconut shrimp, jerk chicken, and paella. They also highlight the lively and tropical atmosphere, with many enjoying the outdoor dining area and live music.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ3VstYO1j_ogRW8GPUZgjS20/photos/AcnlKN0CzUeYUkvfb_Wm59YcFzxqyJKooJknwo2HP6DHj5goC0v2UkBRyxMyeft3hnliqkEu_xf1ul_2InuSAjhKpCpsDYmOBsP1GkusE0XLYaB15BSIs8MLdVAD1SBZyShErpUyqs_zBzrG6SNdzD7OBe2WwiRR0Jtq_gOcFj7OnSZ6UrAjx2lbkC6-ge7anzX4ShQczGwl5xSKeznOZ4FKQepFSHnMUcl2CJJjlWGxfQuVp9wM-_qsVDOaI6AeHScBBZ3vtRh7R0nt9_rBenSOTFPH3AEx94NkqRDMppUXSdbc6jlf9zKiy2NG7MVV9ztvNDSPZ_5sVa4g8llpHFrFdBdCcdXZfymd3tT4TzMdGc8LFuL3ZOxx03yBScDJdnF6_pdDyzQJCYUQAg2h5Ms8mZnmuXRzN9lwG-oMeDsxLvm3oSxsjBNZgOfaCaOftg/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4800&maxHeightPx=3614",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bahamabreeze.com/locations/sc/charleston/north-charleston/3064?cmpid=br:bb_ag:ie_ch:loc_ca:BBGMB_sn:gmb_gt:charleston-sc-3064_pl:locurl_rd:1042",
      "poi_directions_map_url": "https://maps.google.com/?cid=7875427510497821019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bahama-breeze",
      "poi_latitude": "32.9470498",
      "poi_longitude": "-80.04211509999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-405-5779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-4bc138403558",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3VstYO1j_ogRW8GPUZgjS20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9bd4a7b7-c854-4bc5-bb9d-d2b87f9bb1dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Northwoods Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2150 Northwoods Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "Popular shopping center with a variety of clothing shops, shoe stores and other retailers, plus a food court.",
      "poi_long_description": "People say this shopping center has a great mix of well-known stores and local spots, with a wide selection of brands and items, including clothing, shoes, books, beauty, and jewelry. They also highlight the convenient location, laid-back atmosphere, and clean common areas.\n\nOther reviews mention the bathrooms can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-bc31-71df-b1ef-acf08059334a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc31-71df-b1ef-acf08059334a",
        "storage_key": "property/6767906449166428/019d02c7-bc31-71df-b1ef-acf08059334a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.shopnorthwoodsmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2504357657666629369&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northwoods-mall",
      "poi_latitude": "32.944607",
      "poi_longitude": "-80.044319",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-797-3062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a",
        "storage_key": "property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJrQ012tBj_ogR-a6_XwVEwSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f0b085f6-55f9-4f6b-9306-d22ceff03bcc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Charleston Southern University",
      "poi_type": "Education",
      "poi_address": "9200 University Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-c0ac-74e8-9578-5033019f3a9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-c0ac-74e8-9578-5033019f3a9e",
        "storage_key": "property/6767906449166428/019d02c7-c0ac-74e8-9578-5033019f3a9e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.charlestonsouthern.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18389572263007151393&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charleston-southern-university",
      "poi_latitude": "32.9821829",
      "poi_longitude": "-80.07065539999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-863-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-46372e9ca7ee",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCTNMZLlh_ogRIeXqg4riNP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1e8ff178-fa95-4d67-86fe-e210d3c77ae4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Trident Technical College",
      "poi_type": "Education",
      "poi_address": "7000 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-c0cd-7548-a9e3-b1fc2beaf299.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-c0cd-7548-a9e3-b1fc2beaf299",
        "storage_key": "property/6767906449166428/019d02c7-c0cd-7548-a9e3-b1fc2beaf299.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.tridenttech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12635303724822809317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trident-technical-college",
      "poi_latitude": "32.9280591",
      "poi_longitude": "-80.0307641",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 843-574-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-46372e9ca7ee",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaftirupj_ogR5co7A8udWa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1b840e3c-2cb2-48b6-83b1-cbe14da1ae49",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Berkeley County Library - Hanahan Library",
      "poi_type": "Education",
      "poi_address": "1216 Old Murray Ct, Hanahan, SC 29410, USA",
      "poi_short_description": "Library featuring a kiddie area, plus helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-c285-77ea-bf8f-0dfe94fb4667.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-c285-77ea-bf8f-0dfe94fb4667",
        "storage_key": "property/6767906449166428/019d02c7-c285-77ea-bf8f-0dfe94fb4667.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://berkeleylibrarysc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10780698552306831023&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "berkeley-county-library---hanahan-library",
      "poi_latitude": "32.9185954",
      "poi_longitude": "-80.02056879999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-553-0047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-46372e9ca7ee",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOd198cqi5BQRrw7R-Da8nJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_6f9a35e4-a0ec-4be9-8f40-47b14d9e9e7a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "7800 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a wide variety of activities, including bumper cars, a trampoline park, and a ropes course. They also highlight the fun and exciting atmosphere, and the friendly and attentive staff.\n\nSome reviews mention the crowds can be overwhelming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-ca97-72ea-83c9-f85e125e2651.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-ca97-72ea-83c9-f85e125e2651",
        "storage_key": "property/6767906449166428/019d02c7-ca97-72ea-83c9-f85e125e2651.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.urbanair.com/south-carolina-north-charleston/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3609786582506414492&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.9474866",
      "poi_longitude": "-80.03815569999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-737-6775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBzszELFj_ogRnCFEdcWJGDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_cc68d485-3eb5-4588-9e15-9923da6258f5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Crunch Fitness - North Charleston",
      "poi_type": "Health and Wellness",
      "poi_address": "7800 Rivers Ave Ste 1300, North Charleston, SC 29406, USA",
      "poi_short_description": "Clean gym chain offering classes and weights.",
      "poi_long_description": "People say this gym has a wide variety of equipment, including adjustable benches, and a good selection of workout classes. They also highlight the friendly and helpful staff, as well as the clean and motivating environment.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-cede-741e-a8b5-4eb8cd37f70d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-cede-741e-a8b5-4eb8cd37f70d",
        "storage_key": "property/6767906449166428/019d02c7-cede-741e-a8b5-4eb8cd37f70d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/north-charleston",
      "poi_directions_map_url": "https://maps.google.com/?cid=17565199309025101540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---north-charleston",
      "poi_latitude": "32.9465594",
      "poi_longitude": "-80.0376016",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-800-8350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAe-ZiNhj_ogR5MZgB7UfxPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a68e295d-86fa-41be-9058-6ee337ba4ab2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2150 Northwoods Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "Chain with cardio, strength training machines, massage chairs, tanning beds, and free pizza.",
      "poi_long_description": "People say this gym offers a wide selection of well-maintained equipment, including cardio machines, weight machines, and free weights, as well as amenities like tanning beds and massage tables. They also highlight the clean facilities, friendly and accommodating staff, and the non-judgmental, enjoyable atmosphere.\n\nOther reviews mention the cardio equipment TVs can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-ce8b-719b-b1c6-e20c589a671b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-ce8b-719b-b1c6-e20c589a671b",
        "storage_key": "property/6767906449166428/019d02c7-ce8b-719b-b1c6-e20c589a671b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/north-charleston-sc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13367494656862933475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.9440316",
      "poi_longitude": "-80.0454944",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-553-2991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZ8wxtBj_ogR41E__5Dhgrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_18561330-d688-49f4-a72a-82cf330f34b8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Change Up Cuts Barbershop & Beauty Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5900 Rivers Ave Suite D-4, North Charleston, SC 29406, USA",
      "poi_short_description": "Informal barbershop featuring haircuts, beards, Dominican blowouts, braids, plus nail services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-d2b0-72bd-a7f3-167ed6d2a4b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-d2b0-72bd-a7f3-167ed6d2a4b3",
        "storage_key": "property/6767906449166428/019d02c7-d2b0-72bd-a7f3-167ed6d2a4b3.webp",
        "width": 1280,
        "height": 1115
      },
      "poi_business_url": "https://www.changeupcuts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9284503535833538788&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "change-up-cuts-barbershop--beauty-center",
      "poi_latitude": "32.904006",
      "poi_longitude": "-80.01811359999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-789-4430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7DnCGxj_ogR5GA3QcYu2YA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_24bdfc0d-4c3a-4553-91ab-dd43309e9f81",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Air Base Fitness & Sports Center",
      "poi_type": "Health and Wellness",
      "poi_address": "205 W Hill Blvd, Joint Base Charleston, SC 29404, USA",
      "poi_short_description": "Gym, open 24 hours for military card holders, featuring basketball and racquetball courts, along with a cardio room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-d46c-771b-8e0e-333d7663746f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-d46c-771b-8e0e-333d7663746f",
        "storage_key": "property/6767906449166428/019d02c7-d46c-771b-8e0e-333d7663746f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4000392304379752155&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-base-fitness--sports-center",
      "poi_latitude": "32.8956051",
      "poi_longitude": "-80.0577067",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-963-3347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0VCMuNi_ogR2-7CGJs_hDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e0e58399-1911-4ebc-bd37-5734b5836ad6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Against Da Grain (BarberShop)",
      "poi_type": "Health and Wellness",
      "poi_address": "3316 Ashley Phosphate Rd Suite 2, North Charleston, SC 29418, USA",
      "poi_short_description": "Barbershop in Pepperhill Square offering haircuts for men and women in an easygoing setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-d49b-769a-b92e-bbf29be65375.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-d49b-769a-b92e-bbf29be65375",
        "storage_key": "property/6767906449166428/019d02c7-d49b-769a-b92e-bbf29be65375.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://againstdagrain.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=3653993405344246531",
      "poi_directions_map_url": "https://maps.google.com/?cid=9864131171111936717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "against-da-grain-barbershop",
      "poi_latitude": "32.9306364",
      "poi_longitude": "-80.0725099",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-608-8018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxfDkUBi_ogRzSL8pwlv5Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_efa69588-68d4-412a-9d6a-68b53ccab93e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Trident Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9330 Medical Plaza Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-d92d-7123-a35f-a935ae247d3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-d92d-7123-a35f-a935ae247d3f",
        "storage_key": "property/6767906449166428/019d02c7-d92d-7123-a35f-a935ae247d3f.webp",
        "width": 926,
        "height": 521
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/trident-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18177182806905145430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trident-medical-center",
      "poi_latitude": "32.9762786",
      "poi_longitude": "-80.0736211",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-797-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f580-711a-8a5e-56e9e08d8cfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f580-711a-8a5e-56e9e08d8cfb",
        "storage_key": "property/6767906449166428/019d02c7-f580-711a-8a5e-56e9e08d8cfb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTtamr9h_ogRVkjrvnRTQvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b96e5ac5-d3c4-4497-8a86-a367780900b9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1061 Everglades Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "Riverside park for concerts, festivals, picnics and playground fun, plus military-base relics and memorials.",
      "poi_long_description": "Visitors say this park offers scenic walking paths along the river, open green space for picnics, a playground, and a splash pad. They also highlight the family-friendly atmosphere, beautiful views, and historical significance of the park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-dedc-77ec-a81b-fad09ff2007e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-dedc-77ec-a81b-fad09ff2007e",
        "storage_key": "property/6767906449166428/019d02c7-dedc-77ec-a81b-fad09ff2007e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.northcharleston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8626706816767301319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverfront-park",
      "poi_latitude": "32.8675754",
      "poi_longitude": "-79.966717",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-308-4746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f58c-72ef-8c85-ac3c99983215.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f58c-72ef-8c85-ac3c99983215",
        "storage_key": "property/6767906449166428/019d02c7-f58c-72ef-8c85-ac3c99983215.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZpkTthk_ogRxxbbwiQ4uHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_004e57d5-b40c-4fde-b3ea-02918729c730",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Central Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "147 Old Moncks Corner Rd, Goose Creek, SC 29445, USA",
      "poi_short_description": "Large, fenced playground with basketball courts and pickleball courts.",
      "poi_long_description": "Visitors say this park offers a variety of activities, including pickleball courts, a playground, and a splash pad. They also highlight the family-friendly atmosphere and the well-maintained facilities, such as the bathrooms and water fountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-e038-729d-9774-fa7ec7cd4a31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-e038-729d-9774-fa7ec7cd4a31",
        "storage_key": "property/6767906449166428/019d02c7-e038-729d-9774-fa7ec7cd4a31.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofgoosecreek.com/recreation/central-creek-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14849880398891927637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-creek-park",
      "poi_latitude": "33.0148881",
      "poi_longitude": "-80.0449246",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-797-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f58c-72ef-8c85-ac3c99983215.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f58c-72ef-8c85-ac3c99983215",
        "storage_key": "property/6767906449166428/019d02c7-f58c-72ef-8c85-ac3c99983215.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ45YBxRh_ogRVUj9dItfFc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_06bbf467-8082-4d84-8021-e23238d0f526",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "North Charleston Wannamaker County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8888 University Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "Park featuring a water park, plus play areas and picnic spots.",
      "poi_long_description": "Visitors say this park offers a splash pad, dog park, walking trails, playgrounds, and picnic tables. They also highlight that the park is clean, peaceful, and enjoyable for families with kids and dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-e005-7318-80ae-44d6c699b2b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-e005-7318-80ae-44d6c699b2b2",
        "storage_key": "property/6767906449166428/019d02c7-e005-7318-80ae-44d6c699b2b2.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "http://ccprc.com/1737/North-Charleston-Wannamaker-County-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=557002064498803929&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-charleston-wannamaker-county-park",
      "poi_latitude": "32.9771948",
      "poi_longitude": "-80.0541909",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-762-5585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f58c-72ef-8c85-ac3c99983215.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f58c-72ef-8c85-ac3c99983215",
        "storage_key": "property/6767906449166428/019d02c7-f58c-72ef-8c85-ac3c99983215.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6pT-qBh_ogR2UScMW3eugc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_41406b44-e03d-4e6e-a19f-65c71b13a3b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Charleston International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5500 International Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_long_description": "People say this airport is small and easy to navigate. They also highlight the clean facilities, friendly staff, and efficient security process.\n\nOther reviews mention the baggage claim can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-e689-75fd-b07c-f46881255ac9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-e689-75fd-b07c-f46881255ac9",
        "storage_key": "property/6767906449166428/019d02c7-e689-75fd-b07c-f46881255ac9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.iflychs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2038942955165646559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charleston-international-airport",
      "poi_latitude": "32.8916648",
      "poi_longitude": "-80.0395233",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-767-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f9bf-7455-9bb6-52c88a0301af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f9bf-7455-9bb6-52c88a0301af",
        "storage_key": "property/6767906449166428/019d02c7-f9bf-7455-9bb6-52c88a0301af.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyrqSw9j_ogR3_7un9DHSxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_554e6f62-9b79-432d-bf9a-c63f9464ea01",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "City of North Charleston City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2500 City Hall Ln, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-e6bc-714d-8420-213dceb05bbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-e6bc-714d-8420-213dceb05bbc",
        "storage_key": "property/6767906449166428/019d02c7-e6bc-714d-8420-213dceb05bbc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.northcharleston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2612516476197082924&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-north-charleston-city-hall",
      "poi_latitude": "32.8766647",
      "poi_longitude": "-80.0118899",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-554-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-fabf-7337-8660-c2e3f381b54d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-fabf-7337-8660-c2e3f381b54d",
        "storage_key": "property/6767906449166428/019d02c7-fabf-7337-8660-c2e3f381b54d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp1J_3V5j_ogRLBeVteSFQSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_3ae858cb-7f2a-4dcc-b54e-106dbdf9b06b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Roper St. Francis Office Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8536 Palmetto Commerce Pkwy, Ladson, SC 29456, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-e8ec-76fe-baca-ddaf385e00af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-e8ec-76fe-baca-ddaf385e00af",
        "storage_key": "property/6767906449166428/019d02c7-e8ec-76fe-baca-ddaf385e00af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rsfh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5175049599877896670&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roper-st-francis-office-park",
      "poi_latitude": "32.9674728",
      "poi_longitude": "-80.1088399",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-212-8065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw_sQhxqK_ogR3tm_RzF40Uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ad3596de-7bdd-4e01-8b37-3d16c5d90edd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "841st Transportation Battalion (SDDC) HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1050 Remount Rd BLDG 3304, North Charleston, SC 29406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-ec0c-7570-8b1d-d90818e101e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-ec0c-7570-8b1d-d90818e101e9",
        "storage_key": "property/6767906449166428/019d02c7-ec0c-7570-8b1d-d90818e101e9.webp",
        "width": 938,
        "height": 729
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5207660875602154014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "841st-transportation-battalion-sddc-hq",
      "poi_latitude": "32.905178",
      "poi_longitude": "-79.9736022",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-794-0272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbF-T1dk_ogRHlL3mPlTRUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d4d177a8-13fc-4bea-930c-c01c2246cea4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "5041 International Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Diners say this seafood restaurant serves up delicious Bang Bang Shrimp, steak, and a variety of fresh seafood dishes, alongside innovative cocktails and an extensive wine list. They also highlight the friendly and attentive service, and the welcoming atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019eb391-f383-735c-aa77-30ce99a54407.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb391-f383-735c-aa77-30ce99a54407",
        "storage_key": "property/6767906449166428/019eb391-f383-735c-aa77-30ce99a54407.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/south-carolina/north-charleston/5041-international-blvd.?y_source=1_MTU1MDI4MTctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16440838685436424391&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "32.8663724",
      "poi_longitude": "-80.01624369999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 843-747-7735",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-4bc138403558",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-4bc138403558.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0TeylZj_ogRxzDwVq2XKeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_148c0bf5-4ee3-413d-8880-e551859668da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Stars and Strikes",
      "poi_type": "Entertainment",
      "poi_address": "4570 Ladson Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Family entertainment center with bowling, arcade games, laser tag, and bumper cars, plus an American restaurant.",
      "poi_long_description": "Visitors say this entertainment center offers a wide variety of activities, including bowling, arcade games, and laser tag, with many highlighting the fun private karaoke booths. They also appreciate the friendly and attentive staff, with some mentioning the good food and party packages.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019eb392-a929-737a-97b9-7574ac25cf3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb392-a929-737a-97b9-7574ac25cf3a",
        "storage_key": "property/6767906449166428/019eb392-a929-737a-97b9-7574ac25cf3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://starsandstrikes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=414138114840669674&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stars-and-strikes",
      "poi_latitude": "32.9565168",
      "poi_longitude": "-80.1612976",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 678-965-5707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7LUTdaJ_ogR6i0H12tQvwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_e0b1c15d-42a7-41e9-98f3-86abc7b4c509",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "The Promenade at Northwoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7800 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "Shopping mall offering a wide range of stores, including a branch of Hobby Lobby.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-8258-7650-b14d-6e0a56838fe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-8258-7650-b14d-6e0a56838fe6",
        "storage_key": "property/6767906449166428/019f1528-8258-7650-b14d-6e0a56838fe6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hawthorneretailpartners.com/shop_loca_promenade.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072582264948786608&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-promenade-at-northwoods",
      "poi_latitude": "32.9479597",
      "poi_longitude": "-80.03872539999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-333-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a",
        "storage_key": "property/6767906449166428/019d02c7-f21c-76ca-8c0c-aa2e2a69bd2a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJC9065vNj_ogRsAWQqOe2qZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_207d50cf-b2f1-4870-a0fc-466cb8a498be",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "H & L Asian Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5300 Rivers Ave #7, North Charleston, SC 29406, USA",
      "poi_short_description": "Asian grocery store carrying ingredients such as produce, seafood, spices, and kimchi, plus cookware.",
      "poi_long_description": "Visitors say this Asian grocery store offers a wide variety of hard-to-find Asian food items, including fresh produce, frozen foods, and a great selection of ramen. They also highlight the reasonable prices, friendly staff, and the delicious prepared food available in the deli.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-86b4-7368-a880-2099980168f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-86b4-7368-a880-2099980168f1",
        "storage_key": "property/6767906449166428/019f1528-86b4-7368-a880-2099980168f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/pages/category/Supermarket/HL-Asian-Market-155289124513164/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10824265984792248233&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "h--l-asian-market",
      "poi_latitude": "32.891075",
      "poi_longitude": "-80.01089999999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-745-9365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-4ff32e3226be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-4ff32e3226be",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-4ff32e3226be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn9v32mJj_ogRqb_iUZCEN5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_1f4e8d56-0e9d-42d2-a72a-c132fb198f3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "HCA Healthcare Trident Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9330 Medical Plaza Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-7cda-7038-baf8-22e5b8878dd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-7cda-7038-baf8-22e5b8878dd5",
        "storage_key": "property/6767906449166428/019f1528-7cda-7038-baf8-22e5b8878dd5.webp",
        "width": 1010,
        "height": 568
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/trident-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18177182806905145430&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hca-healthcare-trident-hospital",
      "poi_latitude": "32.9762771",
      "poi_longitude": "-80.07362309999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-797-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f580-711a-8a5e-56e9e08d8cfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f580-711a-8a5e-56e9e08d8cfb",
        "storage_key": "property/6767906449166428/019d02c7-f580-711a-8a5e-56e9e08d8cfb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTtamr9h_ogRVkjrvnRTQvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_82e26f87-c61d-4951-8399-b7ed9f83219b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Boeing South Carolina Delivery Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 Airframe Dr, North Charleston, SC 29418, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-7d3b-74f1-9dda-903a5a7eacaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-7d3b-74f1-9dda-903a5a7eacaf",
        "storage_key": "property/6767906449166428/019f1528-7d3b-74f1-9dda-903a5a7eacaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1818565927026470829&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "boeing-south-carolina-delivery-center",
      "poi_latitude": "32.8772636",
      "poi_longitude": "-80.027445",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 312-544-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtVx4OUFj_ogRra8KURPYPBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_9a6a96dc-fe73-4fbc-bfa9-2e26c979278f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Joint Base Charleston",
      "poi_type": "Major Employers & Offices",
      "poi_address": "102 E Hill Blvd, Joint Base Charleston, SC 29404, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-80df-7099-9fb3-9c6067e12594.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-80df-7099-9fb3-9c6067e12594",
        "storage_key": "property/6767906449166428/019f1528-80df-7099-9fb3-9c6067e12594.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "https://www.jbcharleston.jb.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4483304259841560535&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "joint-base-charleston",
      "poi_latitude": "32.8974054",
      "poi_longitude": "-80.05202539999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-963-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-fabf-7337-8660-c2e3f381b54d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-fabf-7337-8660-c2e3f381b54d",
        "storage_key": "property/6767906449166428/019d02c7-fabf-7337-8660-c2e3f381b54d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z4rC-Vi_ogR1w_ag3jlNz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_6ca133c9-548e-45d4-b419-9838cac7037f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "North Charleston Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4565 Gaynor Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-818c-762f-8073-ee9ae2977566.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-818c-762f-8073-ee9ae2977566",
        "storage_key": "property/6767906449166428/019f1528-818c-762f-8073-ee9ae2977566.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridecarta.com/news-announcements/intermodal-facility-project/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18388241308575805294&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "north-charleston-transit-center",
      "poi_latitude": "32.8755257",
      "poi_longitude": "-79.9979853",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-724-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-Lvgxdl_ogRbi_TiQsoMP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_54c41489-b0b9-4a4c-b2d1-ee03c7d3a904",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "CARTA - N. Charleston SuperStop",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rivers Ave & Cosgrove Ave, North Charleston, SC 29405",
      "poi_short_description": "Major CARTA bus transfer center serving multiple local and regional routes",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9462360f-4c65-4379-b590-b84b44d20c6d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "CARTA Route 10 - Rivers Avenue",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rivers Ave & Morris Baker Blvd, North Charleston, SC 29406",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a673b8ec-c780-4e87-b0c0-4ee522ea3ce1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Greyhound Bus Lines",
      "poi_type": "Transportation & Transit",
      "poi_address": "4565 Gaynor Ave, Charleston, SC 29405, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-818c-762f-8073-f18f75694bb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-818c-762f-8073-f18f75694bb8",
        "storage_key": "property/6767906449166428/019f1528-818c-762f-8073-f18f75694bb8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.greyhound.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2342666944400129861&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "greyhound-bus-lines",
      "poi_latitude": "32.8757483",
      "poi_longitude": "-79.9984788",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-744-4247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f564-7651-89bc-cdebdb6e6507",
        "storage_key": "property/6767906449166428/019d02c7-f564-7651-89bc-cdebdb6e6507.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wC1hTV7_ogRRf8EiCzTgiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_f73f9e73-1f3a-493e-898b-af7f095df1ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "North Charleston Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Melnick Dr, North Charleston, SC 29406",
      "poi_short_description": "A CARTA park-and-ride facility where commuters can park and connect to regional bus service, making it a convenient transit option for the North Charleston area",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1efa507e-9265-4929-ac4c-03b6cde109ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Quarterman Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1126 Buist Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "Cozy public park known for its tended green spaces & central pond with a charming fountain.",
      "poi_long_description": "People say this park has a pretty pond with two fountains, a sidewalk circling it, and plenty of ducks, geese, and turtles. They highlight the ample shade provided by trees, the relaxing atmosphere, and the opportunity to feed the ducks and geese. They also like the peaceful setting for walking and enjoying nature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-7cae-707c-8b25-e6245f16e087.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-7cae-707c-8b25-e6245f16e087",
        "storage_key": "property/6767906449166428/019f1528-7cae-707c-8b25-e6245f16e087.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10636365225965740381&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "quarterman-park",
      "poi_latitude": "32.8783021",
      "poi_longitude": "-79.98186299999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-554-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f58c-72ef-8c85-ac3c99983215.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f58c-72ef-8c85-ac3c99983215",
        "storage_key": "property/6767906449166428/019d02c7-f58c-72ef-8c85-ac3c99983215.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Z6f5sFk_ogRXWEBs9H1m5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f58a1c78-6242-4b9e-b09c-37713c0a9d71",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Park Circle",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "156 E Montague Ave, North Charleston, SC 29405",
      "poi_short_description": "A historic garden-style park with walking paths, mature oak trees, open green space, and a popular community gathering area",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_156439ba-cacb-4d2a-9f63-0cc9369a30dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Daniel Island Trails",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "247–251 Fairchild St, Charleston, SC 29492",
      "poi_short_description": "A network of scenic walking and biking trails through marshes and wetlands, offering excellent birdwatching and views of the Wando River.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ea38a76a-ce2e-4efd-a2d8-180ef95f3d0a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "A. C. Corcoran Elementary School",
      "poi_type": "Education",
      "poi_address": "8585 Vistavia Rd, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-84a8-72f0-9214-44e9b901ab7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-84a8-72f0-9214-44e9b901ab7c",
        "storage_key": "property/6767906449166428/019f1528-84a8-72f0-9214-44e9b901ab7c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corcoran.ccsdschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10941791304273518637&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "a-c-corcoran-elementary-school",
      "poi_latitude": "32.9605543",
      "poi_longitude": "-80.0596659",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-764-2218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-46372e9ca7ee",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg5ckgIRh_ogRLWCuGTgN2Zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_73a49dd2-eee5-4270-94bc-5466c7f86836",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "Northwoods Middle School",
      "poi_type": "Education",
      "poi_address": "7763 Northside Dr, North Charleston, SC 29420, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ccsdschools.com/northwoods",
      "poi_directions_map_url": "https://maps.google.com/?cid=11095631829993998939&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwoods-middle-school",
      "poi_latitude": "32.9424449",
      "poi_longitude": "-80.05741139999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-764-2212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-46372e9ca7ee",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWQRUAS1i_ogRW0pPuVya-5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d2e95ad4-eba2-49d0-9b3a-6084e216f5ea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "poi_name": "R.B. Stall High School",
      "poi_type": "Education",
      "poi_address": "3625 Ashley Phosphate Rd, North Charleston, SC 29418, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f1528-7ce8-755c-8a6b-547ed256ac2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1528-7ce8-755c-8a6b-547ed256ac2f",
        "storage_key": "property/6767906449166428/019f1528-7ce8-755c-8a6b-547ed256ac2f.webp",
        "width": 1280,
        "height": 186
      },
      "poi_business_url": "https://www.ccsdschools.com/stall",
      "poi_directions_map_url": "https://maps.google.com/?cid=17338180560998263456&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rb-stall-high-school",
      "poi_latitude": "32.9227581",
      "poi_longitude": "-80.0799828",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-764-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-f1b7-74bc-ab07-46372e9ca7ee",
        "storage_key": "property/6767906449166428/019d02c7-f1b7-74bc-ab07-46372e9ca7ee.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaR8mqS1i_ogRoGrizVuXnfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    }
  ],
  "office_hours": [
    {
      "id": "ec_afb4c168c3d06932ac30a318",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_098d12887ad6336ab6d2413a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_028ab752b25dacc81e26f4b5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e9fc916c14d404521caf6032",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2304dfe6154135b776fc7975",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6a5756a1b35cdd7525b58b06",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d9dd3b0c-8d00-41d3-a1cb-2446cea55834",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "rating": "5.0",
      "name": "Jody Coats",
      "text": "I toured the community skeptical it would live up to its pictures. Boy was a wrong, loved the finishes, the pool was gorgeous, great use of space. I actually had s chance to meet the new Manager Leah, im not sure how new she is but she was very knowledgeable about the area and community a 10 out of 10. This community is at the top of my choices",
      "date": "2025-08-01",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_597f3e5c-c2e3-465d-b059-b21eec67c214",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-41af-73fa-bbfc-549fda8836f5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-41af-73fa-bbfc-549fda8836f5",
        "storage_key": "property/6767906449166428/019f6c18-41af-73fa-bbfc-549fda8836f5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nPgENFa3Bsc"
    },
    {
      "id": "custom_8389ab23-98b3-4e51-9332-2451b2a62319",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-41ca-70a9-8926-f278a3effe5a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-41ca-70a9-8926-f278a3effe5a",
        "storage_key": "property/6767906449166428/019f6c18-41ca-70a9-8926-f278a3effe5a.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Community Tour | Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yu28irXqAJJ"
    },
    {
      "id": "custom_4f450e6a-50e7-41bb-87bf-5a0cd611e3d2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-418b-76aa-9035-3cb55725cb9b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-418b-76aa-9035-3cb55725cb9b",
        "storage_key": "property/6767906449166428/019f6c18-418b-76aa-9035-3cb55725cb9b.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ooMAmWw5svq"
    },
    {
      "id": "custom_489d5476-dc66-4898-8258-1634adbbbc1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-41ca-70a9-8926-f5e984e348bf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-41ca-70a9-8926-f5e984e348bf",
        "storage_key": "property/6767906449166428/019f6c18-41ca-70a9-8926-f5e984e348bf.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Pool Oasis",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nZrqCh7NC5m"
    },
    {
      "id": "custom_c117f30c-2749-44e2-907e-380a372d592e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-418b-76aa-9035-40014e2f99e6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-418b-76aa-9035-40014e2f99e6",
        "storage_key": "property/6767906449166428/019f6c18-418b-76aa-9035-40014e2f99e6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 624 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hXD7Pi1pG1Y"
    },
    {
      "id": "custom_22f93556-5114-4de6-a33d-82bedc50b802",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-418c-751b-a355-577574e84c2b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-418c-751b-a355-577574e84c2b",
        "storage_key": "property/6767906449166428/019f6c18-418c-751b-a355-577574e84c2b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 795 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=C9T8DtSVsQh"
    },
    {
      "id": "custom_490768f6-f85f-476d-8168-83bd4e679b67",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-41ad-7018-a894-f4590199bad4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-41ad-7018-a894-f4590199bad4",
        "storage_key": "property/6767906449166428/019f6c18-41ad-7018-a894-f4590199bad4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1038 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mxN31kPLHVA"
    },
    {
      "id": "custom_68d73a2a-a4b9-4c8d-a77f-091eae2668cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-418b-76aa-9035-475dcdf61ac6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-418b-76aa-9035-475dcdf61ac6",
        "storage_key": "property/6767906449166428/019f6c18-418b-76aa-9035-475dcdf61ac6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1214 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3zuZKQ1nj35"
    },
    {
      "id": "custom_f1e33bb6-c583-4395-9fcd-e7123d1dc45f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-41ab-71be-8c1b-a718302e34da.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-41ab-71be-8c1b-a718302e34da",
        "storage_key": "property/6767906449166428/019f6c18-41ab-71be-8c1b-a718302e34da.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 3 BR, 2 BA | 1421 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nEDbQtasHPn"
    },
    {
      "id": "custom_25f6dbaf-9799-47a3-9a9d-69b4d7cdda7e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-41ab-71be-8c1b-a2486b1c5989.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-41ab-71be-8c1b-a2486b1c5989",
        "storage_key": "property/6767906449166428/019f6c18-41ab-71be-8c1b-a2486b1c5989.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1241 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=s4rBwG4Yfc3"
    },
    {
      "id": "custom_070d20da-b4a7-4ea1-adf5-8c0feda9600b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-418b-76aa-9035-40014e2f99e6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-418b-76aa-9035-40014e2f99e6",
        "storage_key": "property/6767906449166428/019f6c18-418b-76aa-9035-40014e2f99e6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 624 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hXD7Pi1pG1Y"
    },
    {
      "id": "custom_86c71077-8e7b-4b80-a874-9c198db05331",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-41ab-71be-8c1b-a2486b1c5989.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-41ab-71be-8c1b-a2486b1c5989",
        "storage_key": "property/6767906449166428/019f6c18-41ab-71be-8c1b-a2486b1c5989.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1241 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=s4rBwG4Yfc3"
    },
    {
      "id": "custom_a4fd47cb-8bea-47b4-be62-be5f9cac1d38",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-41ab-71be-8c1b-a718302e34da.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-41ab-71be-8c1b-a718302e34da",
        "storage_key": "property/6767906449166428/019f6c18-41ab-71be-8c1b-a718302e34da.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 3 BR, 2 BA | 1421 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nEDbQtasHPn"
    },
    {
      "id": "custom_d482f41c-ce6e-4b76-a4a6-58ff5b443172",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-47aa-702f-a064-95c79caf8b99.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-47aa-702f-a064-95c79caf8b99",
        "storage_key": "property/6767906449166428/019f6c18-47aa-702f-a064-95c79caf8b99.webp",
        "width": 512,
        "height": 256
      },
      "virtual_tour_title": "Community Tour | Full Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=5db95a7c76f335192713de2e"
    },
    {
      "id": "custom_250ed291-2cdf-4c01-9400-8725934f68e6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166428/019f6c18-47ab-76ac-880c-2b209cae0fe1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-47ab-76ac-880c-2b209cae0fe1",
        "storage_key": "property/6767906449166428/019f6c18-47ab-76ac-880c-2b209cae0fe1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 624 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=aFhwRt53StK"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfb4-2ad8-77a8-b8de-3b63eb2dd8c9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-atlantic-on-the-boulevard-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "gated-community-apartments-north-charleston",
      "search_query": "gated community apartments north charleston",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in North Charleston",
      "h2_subtitle": "Discover gated community apartments at Atlantic on the Boulevard. Experience modern living and fantastic amenities in North Charleston.",
      "page_copy": "Looking for gated community apartments in North Charleston? Atlantic on the Boulevard offers just that and more. Nestled in a thriving part of North Charleston, our community provides the security and peace of mind you're looking for while being surrounded by vibrant city life. \n\nAt Atlantic on the Boulevard, residents enjoy top-of-the-line amenities like a resort-style pool, a gaming lawn perfect for outdoor activities, and a business center equipped with iMacs. Each apartment features modern comforts such as walk-in closets and stylish window coverings, making it the ideal place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments North Charleston",
      "seo_description": "Explore gated community apartments at Atlantic on the Boulevard, featuring top-notch amenities in North Charleston.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-charleston-county",
      "search_query": "resort style pool apartments charleston county",
      "category": "Amenity",
      "h1_title": "Resort Style Pool Apartments in Charleston County",
      "h2_subtitle": "Atlantic on the Boulevard offers resort style pool apartments. Experience luxury living in the heart of Charleston County.",
      "page_copy": "Atlantic on the Boulevard is the destination for resort style pool apartments in Charleston County. Our stunning pool area provides a refreshing escape, perfect for relaxing and unwinding after a busy day in the city. It's just one of the many amenities that make our community stand out.\n\nLocated in North Charleston, our apartments offer more than just a pool. Residents enjoy a gaming lawn, a business center featuring iMac computers, and intelligently designed spaces with walk-in closets and elegant window coverings. Living at Atlantic on the Boulevard means experiencing the best in comfort and convenience in a vibrant community setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool Apartments Charleston County",
      "seo_description": "Discover resort style pool apartments at Atlantic on the Boulevard in Charleston County with exciting amenities and luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "apartments-with-business-center-in-29406",
      "search_query": "apartments with business center in 29406",
      "category": "Amenity",
      "h1_title": "Apartments with Business Center in 29406",
      "h2_subtitle": "Find apartments with a business center at Atlantic on the Boulevard. Located in the 29406 area, enjoy modern amenities in North Charleston.",
      "page_copy": "If you're searching for apartments with a business center in the 29406 area, Atlantic on the Boulevard has you covered. Our state-of-the-art business center, equipped with iMac computers, provides residents with a quiet and professional environment just steps from their home.\n\nAlongside our business facilities, Atlantic on the Boulevard offers luxurious amenities such as a resort-style pool and a unique gaming lawn. Each apartment is designed with style and convenience in mind, featuring spacious walk-in closets and contemporary window coverings. Experience the perfect blend of work and leisure in North Charleston at Atlantic on the Boulevard.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Business Center in 29406",
      "seo_description": "Discover North Charleston's Atlantic on the Boulevard with a business center, resort-style amenities, and more in the 29406 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "24-hour-fitness-center-apartments-near-north-charleston",
      "search_query": "24 hour fitness center apartments near north charleston",
      "category": "Amenity",
      "h1_title": "24-Hour Fitness Center Apartments Near North Charleston",
      "h2_subtitle": "Discover apartments with a 24-hour fitness center near North Charleston. Atlantic on the Boulevard blends convenience with luxury living.",
      "page_copy": "Looking for apartments with a 24-hour fitness center near North Charleston? Atlantic on the Boulevard is the perfect choice for those who value convenience and an active lifestyle. While our community doesn't currently feature a dedicated fitness center, the local area offers excellent recreational facilities just a short distance away.\n\nResidents of Atlantic on the Boulevard can enjoy a plethora of other amenities such as a resort-style pool, a gaming lawn, and a fully equipped business center with iMacs. Our apartments boast modern conveniences like spacious walk-in closets and attractive window coverings, making it an ideal home base for those who love fitness and relaxation in equal measure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Fitness Center Apartments Near North Charleston",
      "seo_description": "Explore North Charleston's Atlantic on the Boulevard, offering convenience and luxury with key amenities near local fitness centers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "modern-kitchen-apartments-charleston-sc",
      "search_query": "modern kitchen apartments charleston sc",
      "category": "Amenity",
      "h1_title": "Modern Kitchen Apartments in Charleston, SC",
      "h2_subtitle": "Experience the charm of modern kitchen apartments at Atlantic on the Boulevard. Nestled in Charleston, SC, offering style and practicality.",
      "page_copy": "Discover the allure of modern kitchen apartments in Charleston, SC, at Atlantic on the Boulevard. Our thoughtfully designed homes boast contemporary kitchens that cater to all your culinary needs, blending functionality with modern aesthetics.\n\nBeyond stylish kitchens, our community features a range of amenities that elevate living experiences, including a stunning resort-style pool, a vibrant gaming lawn, and a business center complete with iMac computers. Each apartment includes spacious walk-in closets and chic window coverings, making Atlantic on the Boulevard a sought-after address for those who love both culinary excellence and comfortable living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Kitchen Apartments Charleston, SC",
      "seo_description": "Find modern kitchen apartments in Charleston, SC, at Atlantic on the Boulevard with luxury amenities for a stylish lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "one-bedroom-apartment-north-charleston-sc",
      "search_query": "one bedroom apartment North Charleston SC",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartment in North Charleston, SC",
      "h2_subtitle": "Find your ideal one bedroom apartment at Atlantic on the Boulevard. Experience comfort and style in North Charleston, SC.",
      "page_copy": "If you're in search of a cozy one bedroom apartment in North Charleston, SC, look no further than Atlantic on the Boulevard. Our one bedroom apartments offer the perfect blend of comfort and contemporary design, providing a welcoming sanctuary to call home.\n\nResidents enjoy a wealth of community amenities such as a sparkling resort-style pool, a lush gaming lawn, and a well-equipped business center with iMac computers. Each apartment features luxurious walk-in closets and elegant window coverings, ensuring a high standard of living in a vibrant community setting. Choose Atlantic on the Boulevard for your next one bedroom apartment in North Charleston.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartment North Charleston, SC",
      "seo_description": "Explore one bedroom apartments at Atlantic on the Boulevard in North Charleston, SC, offering modern luxury and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-charleston-county",
      "search_query": "two bedroom apartments Charleston County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Charleston County",
      "h2_subtitle": "Explore spacious two bedroom apartments at Atlantic on the Boulevard. Located in the heart of Charleston County.",
      "page_copy": "Looking for spacious two bedroom apartments in Charleston County? Atlantic on the Boulevard offers the perfect solution with well-appointed residences that provide the ideal mix of style and practicality. Our two bedroom floor plans accommodate both individuals and families, ensuring comfortable living with plenty of room to grow.\n\nAlongside our beautifully designed interiors, residents can enjoy a suite of top-notch amenities. Relax by our resort-style pool, engage in outdoor activities on our gaming lawn, or stay productive at our iMac-equipped business center. Each apartment includes generous walk-in closets and stylish window coverings. Experience the superior lifestyle offered by our two bedroom apartments in Charleston County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Charleston County",
      "seo_description": "Discover two bedroom apartments at Atlantic on the Boulevard in Charleston County, featuring modern designs and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-29406",
      "search_query": "three bedroom apartments near 29406",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 29406",
      "h2_subtitle": "Find spacious three bedroom apartments at Atlantic on the Boulevard, conveniently located near the 29406 area.",
      "page_copy": "For those seeking spacious three bedroom apartments near the 29406 area, Atlantic on the Boulevard is the perfect choice. Our three bedroom homes are designed with both comfort and convenience in mind, offering ample space for families and roommates alike.\n\nResidents of Atlantic on the Boulevard enjoy a wide array of community amenities, including a refreshing resort-style pool, a dynamic gaming lawn, and a comprehensive business center featuring iMac computers. Each apartment is outfitted with expansive walk-in closets and fashionable window coverings, ensuring a high-quality living environment in the heart of Charleston County. Choose us for your three bedroom apartment near 29406.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 29406",
      "seo_description": "Explore three bedroom apartments at Atlantic on the Boulevard near 29406, offering luxury living and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "apartments-near-charleston-southern-university-north-charleston",
      "search_query": "apartments near charleston southern university north charleston",
      "category": "School",
      "h1_title": "Apartments Near Charleston Southern University",
      "h2_subtitle": "Discover modern apartments near Charleston Southern University at Atlantic on the Boulevard in North Charleston.",
      "page_copy": "If you're searching for convenient apartments near Charleston Southern University in North Charleston, Atlantic on the Boulevard offers the ideal location and amenities. Our community is perfectly situated to offer easy access to campus, making it an excellent choice for students and staff.\n\nAt Atlantic on the Boulevard, residents can take advantage of our resort-style pool and gaming lawn, perfect for relaxation and recreation. Our business center, equipped with iMacs, provides a productive environment for studying or working. Each apartment boasts generous walk-in closets and stylish window coverings, ensuring a perfect blend of comfort and convenience near Charleston Southern University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Charleston Southern University",
      "seo_description": "Find apartments near Charleston Southern University at Atlantic on the Boulevard in North Charleston, offering luxury and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "north-charleston-apartments-close-to-trident-tech",
      "search_query": "north charleston apartments close to trident technical college",
      "category": "School",
      "h1_title": "North Charleston Apartments Near Trident Tech",
      "h2_subtitle": "Discover convenient apartments in North Charleston, close to Trident Technical College, at Atlantic on the Boulevard.",
      "page_copy": "Atlantic on the Boulevard offers ideal living options for those seeking North Charleston apartments close to Trident Technical College. Our community provides a perfect balance of location and lifestyle, making it an excellent choice for students and educators seeking easy campus access.\n\nEnjoy the many amenities available, including a resort-style pool and a gaming lawn perfect for unwinding after a day of classes. Our business center with iMacs offers a great space for studying or work, and our apartments feature walk-in closets and chic window coverings for added comfort. Choose Atlantic on the Boulevard for convenient, comfortable living near Trident Technical College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Charleston Apartments Close to Trident Tech",
      "seo_description": "Find North Charleston apartments near Trident Technical College at Atlantic on the Boulevard, offering ideal living and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "apartments-near-trident-medical-center-north-charleston",
      "search_query": "apartments near Trident Medical Center North Charleston",
      "category": "Hospital",
      "h1_title": "Apartments Near Trident Medical Center",
      "h2_subtitle": "Explore our apartments near Trident Medical Center in North Charleston, offering comfort and convenience at Atlantic on the Boulevard.",
      "page_copy": "Atlantic on the Boulevard provides the perfect location for those in search of apartments near Trident Medical Center in North Charleston. Our community is ideally positioned for healthcare professionals, patients, and families needing proximity to the center while enjoying a peaceful living environment.\n\nResidents at Atlantic on the Boulevard can take advantage of our resort-style pool, perfect for relaxation, and our engaging gaming lawn for recreation. Our business center, complete with iMac computers, supports study or work needs. Each apartment offers spacious walk-in closets and tasteful window coverings, creating a comfortable and stylish home close to Trident Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Trident Medical Center",
      "seo_description": "Discover apartments near Trident Medical Center in North Charleston at Atlantic on the Boulevard, offering comfort and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "rentals-close-to-musc-health-charleston-county",
      "search_query": "rentals close to MUSC Health Charleston County",
      "category": "Hospital",
      "h1_title": "Rentals Near MUSC Health Charleston County",
      "h2_subtitle": "Discover exceptional rentals near MUSC Health in Charleston County at Atlantic on the Boulevard, offering premium amenities and comfort.",
      "page_copy": "Atlantic on the Boulevard offers unparalleled rentals close to MUSC Health in Charleston County, providing an ideal place for healthcare professionals, patients, and their families. Our location ensures a convenient commute while maintaining a relaxing atmosphere away from the hustle and bustle.\n\nThe community boasts luxurious amenities such as a resort-style pool and a recreational gaming lawn, perfect for leisure and rejuvenation. Our business center, featuring iMac computers, accommodates work or study needs efficiently. Each apartment is designed with spacious walk-in closets and elegant window coverings, offering both functionality and style near MUSC Health Charleston County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near MUSC Health Charleston County",
      "seo_description": "Find rentals close to MUSC Health in Charleston County at Atlantic on the Boulevard, providing luxury and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "apartments-near-riverfront-park-north-charleston",
      "search_query": "apartments near Riverfront Park North Charleston",
      "category": "Park",
      "h1_title": "Apartments Near Riverfront Park North Charleston",
      "h2_subtitle": "Explore Atlantic on the Boulevard, offering exceptional apartments near Riverfront Park in North Charleston, perfect for nature and recreation lovers.",
      "page_copy": "Nestled in North Charleston, Atlantic on the Boulevard provides the ideal living environment with our apartments near Riverfront Park. This prime location offers easy access to one of the area’s most beautiful green spaces, perfect for outdoor activities and serene strolls.\n\nResidents enjoy top-tier amenities, including a resort-style pool for relaxation and a vibrant gaming lawn for fun-filled afternoons. Our apartments come equipped with stylish walk-in closets and modern window coverings, ensuring comfort and elegance. Experience the perfect blend of nature and luxury at Atlantic on the Boulevard, near Riverfront Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Riverfront Park North Charleston",
      "seo_description": "Discover top-rated apartments near Riverfront Park in North Charleston at Atlantic on the Boulevard, offering luxury and proximity to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "rental-homes-close-to-central-creek-park-29406",
      "search_query": "rental homes close to Central Creek Park 29406",
      "category": "Park",
      "h1_title": "Rental Homes Near Central Creek Park 29406",
      "h2_subtitle": "Discover beautiful rental homes close to Central Creek Park. Located in the 29406 area, Atlantic on the Boulevard offers a perfect blend of convenience and comfort.",
      "page_copy": "Atlantic on the Boulevard provides stunning rental homes close to Central Creek Park, nestled in the 29406 area. Offering an oasis for nature lovers and families alike, our location ensures easy access to the park's scenic beauty and outdoor activities.\n\nOur community is adorned with luxurious amenities such as a resort-style pool and a spacious gaming lawn, enhancing the relaxation and recreational options for all residents. Each rental home is thoughtfully designed with expansive walk-in closets and elegant window coverings, blending style with practicality. Choose Atlantic on the Boulevard for premier living near Central Creek Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Central Creek Park 29406",
      "seo_description": "Explore rental homes close to Central Creek Park in the 29406 area at Atlantic on the Boulevard, offering luxury and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166428",
      "source": "generator",
      "page_item_url": "apartment-living-near-wannamaker-county-park-charleston",
      "search_query": "apartment living near North Charleston Wannamaker County Park Charleston County",
      "category": "Park",
      "h1_title": "Apartment Living Near Wannamaker County Park",
      "h2_subtitle": "Experience premier apartment living near North Charleston Wannamaker County Park. Atlantic on the Boulevard offers unmatched comfort in Charleston County.",
      "page_copy": "Atlantic on the Boulevard is the perfect choice for those seeking apartment living near North Charleston Wannamaker County Park in Charleston County. Our location brings nature enthusiasts closer to biking, picnicking, and enjoying the expansive green spaces this park has to offer.\n\nEnjoy unparalleled amenities that include a resort-style pool for leisurely days and a gaming lawn for social activities. Our apartments are designed with spacious walk-in closets and fashionable window coverings, providing comfort and style. Embrace the blend of convenience and elegance at Atlantic on the Boulevard, ideal for those wanting proximity to Wannamaker County Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Wannamaker County Park",
      "seo_description": "Find apartment living near North Charleston Wannamaker County Park in Charleston County at Atlantic on the Boulevard, ensuring luxury and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5298"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425208"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=79d25e60bae654cbd98662577e581a7c629da9ac521002fd8cf25cf05560aad44c5cc9d5ab74ff50eeef47d18bcf4a63\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WSFQNMPR"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "833AOB"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40238743198"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "119370"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Atlantic on the Boulevard/scheduletourwidget/bmI19JWo6P4wuh9jHl/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InE2TDU3QnJjeDhBWTV5c1BSQ3dGbWc9PSIsInZhbHVlIjoiMnI3dC9wTUkzMjM0eXV4L0taMHB3dz09IiwibWFjIjoiMjg4NDc5NzE1NjU2ZmFjNjZlYTRiMzk2NGFkNjNhZWFhOThmOTNhODk5Y2E0ODkwMTAwZTc2MmI0NDNlN2YxNCJ9"
    }
  ],
  "custom_qb_id": "5298",
  "custom_repli_id": "18104425208",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=79d25e60bae654cbd98662577e581a7c629da9ac521002fd8cf25cf05560aad44c5cc9d5ab74ff50eeef47d18bcf4a63\"></script>",
  "custom_google_gtm_id": "GTM-WSFQNMPR",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "833AOB",
  "custom_hubspot_company_id": "40238743198",
  "custom_broker_license_number": "119370",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Atlantic on the Boulevard/scheduletourwidget/bmI19JWo6P4wuh9jHl/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InE2TDU3QnJjeDhBWTV5c1BSQ3dGbWc9PSIsInZhbHVlIjoiMnI3dC9wTUkzMjM0eXV4L0taMHB3dz09IiwibWFjIjoiMjg4NDc5NzE1NjU2ZmFjNjZlYTRiMzk2NGFkNjNhZWFhOThmOTNhODk5Y2E0ODkwMTAwZTc2MmI0NDNlN2YxNCJ9",
  "custom_audioeye_site_id": "8f90dc07-4324-4c25-b978-92e2991d7da5",
  "custom_audioeye_site_hash": "b92221214c65cfc8e83f4a979e2d1ac1"
};

export const generatedAt = '2026-08-21T22:00:27.381Z';
